var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard__wrapper",class:_vm.routeName},[_vm._t("before-content"),_c('div',{staticClass:"dashboard__wrapper-inner"},[_vm._t("default"),_c('RouterModal')],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }